// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"678":"536d8b8c","1860":"15149fd5","2236":"b6f78de0","2425":"36205f9f","7490":"1797386a"}[chunkId] + ".css";
};